import { Accordion, Alert, Card, Checkbox, Col, DropdownBox, InputField, Label, OutlineButton, PopupDialogbox, PrimaryButton, ReactSelectBox, Row, SofturaTable, Tooltip } from "client/CommonComponents"
import Completed from "../../../assets/images/PenndingApproval/Approved.svg"
import moment from "moment";
import RequestDetails from "./RequestDetails";
import AssetDetail from "./AssetDetail";
import './AssetFleetProcessing.scss'
import LeasedOwnedTaskStepper from "./LeasedOwnedTaskStepper";
import ChangeLog from "./ChangeLog";
import { CONSTANTS } from "client/utils/constants";
import Cancelled from "../../../assets/images/MyOrders/Cancelled.svg";
import CancelConfirmationPopup from "client/CommonComponents/DialogBox/CancelConfirmationPopup";
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";
import { useState, useMemo } from "react";
import AfeDetail from "./AfeDetail";

const AssetFleetProcessing = (props: any) => {

  const {
    assetOrderHeaderDetail,
    onChangeReceivingCostCenter,
    setAssignedToError,
    assignedToError,
    transferData,
    setAttachmentChangeFleetId,
    attachmentChangeFleetId,
    commentHistoryList,
    commentHistoryColumn,
    Popupcontent,
    hideConfirmationDialog,
    receivingBranchValues,
    dismissAlert,
    setNewAssetError,
    newAssetError,
    OnSaveComments,
    onChangeComments,
    commentsError,
    isReceivingBranchDisable,
    SavedAdminTaskValue,
    setAssetDeterminationValue,
    assetDeterminationValue,
    setNewAssetValue,
    newAssetValue,
    comments,
    getItemStatus,
    getItemStatusValue,
    getFleetItemStatus,
    getFleetItemStatusValue,
    isShowComplete,
    setActiveStepperArr,
    activeStepperArr,
    isShowAlert,
    iscommentFieldDisable,
    setIsChnagedOccuredFlag,
    showPaymentInformation,
    validatePaymentInfo,
    setValidatePaymentInfo,
    id,
    onChangeAccordian,
    onChangeCommentsAccordian,
    isShowCancelled,
    setCancelComments,
    cancelComments,
    handleorderLevelReturn,
    returnPopupcontent,
    getShowOrderReturn,
    searchCostCenter,
    costCentersBySearchList,
    getOrderQty,
    onAssignedToToggleChange,
    isAssignedToChecked,
    onAssignedToDropdownChange,
    assignTo,
    assignedToForAllValue,
    afeFleetHeaderDetail
  } = props;

  const assignToValue = useMemo(() => {
    return assignTo?.find(
      (x: any) => x.value === (assignedToForAllValue || "N/A")
    );
  }, [assignedToForAllValue, assignTo]);

  const ExpandedItems = [
    {
      headerText: (
        <div className="accordionHeader">
          <div className="accordionHeaderLeft mt-1">
            <p className="accord-heading">
              LEADR ORDER# - {assetOrderHeaderDetail?.orderRequestId}
            </p>
          </div>
          <div className="accordionHeaderRight">
            <div>
              <label className="labelText">Request Type</label>
              <Tooltip content={assetOrderHeaderDetail?.orderRequestType || '-'} data-attribute="AssetFleetProcessing_Default_Tooltip">
                <span className="dateContent">
                  {assetOrderHeaderDetail?.orderRequestType || '-'}
                </span>
              </Tooltip>
            </div>
            {assetOrderHeaderDetail?.orderRequestType == CONSTANTS.AFEREQUEST && <div>
              <label className="labelText">AFE Type</label>
              <Tooltip content={assetOrderHeaderDetail?.afeType || '-'} data-attribute="AssetFleetProcessing_Default_Tooltip_2">
                <span className="dateContent">
                  {assetOrderHeaderDetail?.afeType || '-'}
                </span>
              </Tooltip>
            </div>}
            <div>
              <label className="labelText">Created Date</label>
              <span className="dateContent">
                {assetOrderHeaderDetail?.createdDate
                  ? moment(assetOrderHeaderDetail?.createdDate).format(
                    "MM/DD/YYYY"
                  )
                  : "-"}
              </span>
            </div>
            <div>
              <label className="labelText">Updated Date</label>
              <span className="dateContent">
                {(assetOrderHeaderDetail?.updatedDate || SavedAdminTaskValue?.updatedDate)
                  ? moment(SavedAdminTaskValue?.updatedDate ? SavedAdminTaskValue?.updatedDate : assetOrderHeaderDetail?.updatedDate).format(
                    "MM/DD/YYYY"
                  )
                  : "-"}
              </span>
            </div>
            <div>
              <label className="labelText">Requested By</label>
              <Tooltip content={assetOrderHeaderDetail?.requestedBy || '-'} data-attribute="AssetFleetProcessing_Default_Tooltip_3">
                <span className="dateContent">
                  {assetOrderHeaderDetail?.requestedBy || '-'}
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      ),
      content: <RequestDetails id={id} setIsChnagedOccuredFlag={setIsChnagedOccuredFlag} />,
      uuid: `Fleet_Accordion`,
    },
  ];

  const getExpandedAssetItems = (request: any) => {
    const ExpandedAssetItems: any[] = [];
    request?.fleetAssetDetails?.forEach((item: any, index: any) => {
      ExpandedAssetItems.push(
        {
          headerText: (
            <div className="LeaderOrderHeader driverDetail assetFleetDriverDetail">
              <div className="LeadrOrderSubTitle mt-0">
                <div className="asset">
                  <p className="label">Item ID</p>
                  <Tooltip content={item?.orderRequestId + ' - ' + item?.itemNumber} data-attribute="AssetFleetProcessing_Default_Tooltip_4"><p>{item?.orderRequestId + ' - ' + item?.itemNumber || '-'}</p></Tooltip>
                </div>
                {(assetOrderHeaderDetail?.afeType != CONSTANTS.LEASEHOLD_IMPROVEMENTS && assetOrderHeaderDetail?.afeType != CONSTANTS.FURNITURE_FIXTURE_OFFICE_EQUIP) && 
                <>
                  <div className="asset">
                    <p className="label">Asset #</p>
                    <Tooltip content={item?.assetNo} data-attribute="AssetFleetProcessing_Default_Tooltip_5"><p>{item?.assetNo || '-'}</p></Tooltip>
                  </div>
                  <div className="description">
                    <p className="label">Description</p>
                    <Tooltip content={item?.description} data-attribute="AssetFleetProcessing_Default_Tooltip_6"><p>{item?.description || '-'}</p></Tooltip>
                  </div>
                </>}
                <div className="itemStatus">
                  <p className="label">Item Status</p>
                  <p className="fleetValue">
                    <span>{getItemStatus(item?.itemStatus, item?.fleetRequestDetailId)}</span>
                    <span>{getItemStatusValue(item?.itemStatus, item?.fleetRequestDetailId)}</span>
                  </p>
                </div>
                <div className="fleetSatus">
                  <p className="label">Fleet Status</p>
                  <p className="fleetValue">
                    <span>{getFleetItemStatus(item?.fleetStatus, item?.fleetRequestDetailId)}</span>
                    <span>{getFleetItemStatusValue(item?.fleetStatus, item?.fleetRequestDetailId)}</span>
                  </p>
                </div>
                <div className="assetFleetApprImg">
                  {isShowComplete(item?.fleetStatus, item?.fleetRequestDetailId) ?
                    <img
                      src={Completed}
                      alt="status"
                      title="status"
                      className="me-2"
                    /> : null}
                  {
                    isShowCancelled(item?.fleetStatus, item?.fleetRequestDetailId) ? (
                      <img
                        src={Cancelled}
                        alt="status"
                        title="status"
                        className="me-1 cancelFleetIcon"
                      />
                    ) : null
                  }
                </div>
              </div>
            </div>
          ),
          content: <>
            {assetOrderHeaderDetail?.orderRequestType === CONSTANTS.AFEREQUEST ? 
              <AfeDetail                 
                item = {item} 
                assetOrderHeaderDetail = {assetOrderHeaderDetail}
              /> : 
              <AssetDetail activeStepperArr = {activeStepperArr} setActiveStepperArr = {setActiveStepperArr} setNewAssetValue = {setNewAssetValue} setAssetDeterminationValue = {setAssetDeterminationValue} setNewAssetError = {setNewAssetError} newAssetError = {newAssetError} attachmentChangeFleetId = {attachmentChangeFleetId} setAttachmentChangeFleetId = {setAttachmentChangeFleetId} item = {request?.fleetAssetDetails} assignedToError = {assignedToError} setAssignedToError = {setAssignedToError} orderType={assetOrderHeaderDetail?.orderRequestType} assetDetails={item} />}
            <LeasedOwnedTaskStepper
              activeStepper={props?.activeStepper}
              setActiveStepper={props?.setActiveStepper}
              activeStepperArr = {activeStepperArr}
              setActiveStepperArr = {setActiveStepperArr}
              newAssetValue = {newAssetValue}
              setNewAssetValue = {setNewAssetValue}
              assetDeterminationValue = {assetDeterminationValue}
              setAssetDeterminationValue = {setAssetDeterminationValue}
              setNewAssetError = {setNewAssetError}
              newAssetError = {newAssetError}
              requestFleetAssetDetails = {request}
              attachmentChangeFleetId = {attachmentChangeFleetId}
              setAttachmentChangeFleetId = {setAttachmentChangeFleetId}
              transferData = {props?.transferData}
              assetOrderHeaderDetail = {props?.assetOrderHeaderDetail}
              assignedToError = {assignedToError}
              setAssignedToError = {setAssignedToError}
              orderDetails={props?.orderDetails}
              item = {item } 
              isShowComplete={isShowComplete}
              setIsChnagedOccuredFlag={setIsChnagedOccuredFlag}
              showPaymentInformation={showPaymentInformation}
              validatePaymentInfo={validatePaymentInfo}
              setValidatePaymentInfo={setValidatePaymentInfo}
              setCancelComments = {setCancelComments}
              cancelComments = {cancelComments}
            />
            <ChangeLog fleetRequestDetailId={item?.fleetRequestDetailId} activeStepper={props?.activeStepper} />
          </>,
          uuid: `FleetAsset_Accordion_${item?.fleetRequestDetailId}`,
        },
      )
    })

    return ExpandedAssetItems;
  }

  const ExpandedItemsFleetComment = [
    {
      headerText: (
        <div className="accordionHeader">
          <div className="accordionHeaderLeft mt-1">
            <p className="accord-heading">
              FLEET COMMENTS HISTORY
            </p>
          </div>
        </div>
      ),
      content: <div className="softura-table mb-3 p-3">
        <SofturaTable
          data={commentHistoryList}
          columns={commentHistoryColumn}
          sort={true}
          defaultPageSize={10}
          pageSizes={[10, 20, 50]}
          globalSearch={false}
         data-attribute="AssetFleetProcessing_Default_Grid" />
      </div>,
      uuid: `Fleet_ChangeLog_Accordion`,
    },
  ];

  return (
    <>
      <Row>
        <Col xs={12} lg={12}>
          <div className="card-radius">
            <Card data-attribute="AssetFleetProcessing_Default_Card">
              <Accordion
                Items={ExpandedItems}
                preExpanded={["Fleet_Accordion"]}
                className="custom-accordion LeaderOrderAccordion capitalLizeAccord"
               data-attribute="AssetFleetProcessing_Default_Accordion" />
              <div>
                <div className="ChangeLog ChangeLog-Asset fleethistorycomment">
                  <Accordion
                    Items={ExpandedItemsFleetComment}
                    className="custom-accordion LeaderOrderAccordion capitalLizeAccord"
                    onChange={(item: any) => { onChangeCommentsAccordian(item) }}
                   data-attribute="AssetFleetProcessing_Default_Accordion_2" />
                </div>
                {getOrderQty() > 1 &&
                  <>
                    <div className="checkbox_assignedto">
                      <div className="inside-checkbox assetfleetcheck">
                        <Checkbox
                          onChange={(e: any) => onAssignedToToggleChange(e)}
                          disabled={assetOrderHeaderDetail?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED || assetOrderHeaderDetail?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED}
                          checked={!!isAssignedToChecked}
                          defaultChecked={false}
                         data-attribute="AssetFleetProcessing_Default_Checkbox" />
                        <span className="block-Text consolidatePO-block-text">
                          Set Assigned To for all Items
                        </span>
                      </div>
                      <Col xs={12} sm={12} md={4} lg={6} xl={6} className="assignedTo-fleet">
                        <Label data-attribute="AssetFleetProcessing_Default_Label">Assigned To</Label>
                        <DropdownBox
                          name="assignedTo"
                          placeholder="Select"
                          options={assignTo}
                          onChange={onAssignedToDropdownChange}
                          selectedKey={assignToValue?.key}
                          disabled = {assetOrderHeaderDetail?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED || assetOrderHeaderDetail?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED || !isAssignedToChecked}
                         data-attribute="AssetFleetProcessing_assignedTo_Dropdown" />
                      </Col>
                    </div>
                  </>}
                <div className="fleethistorycomment">
                  <p className="blueLabel">Fleet Request User Comments</p>
                  <InputField
                    multiline={true} resizable={false}
                    className={commentsError?.length ? "controlValidation" : ""}
                    onChange={(e?: any, item?: any) => {onChangeComments(e,item)}}
                    value={comments}
                    disabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS) || iscommentFieldDisable()} data-attribute="AssetFleetProcessing_Default_Input" />
                  {commentsError?.length ? <p className='validMessage'>{commentsError}</p> : ""}
                </div>
              </div>
              <div className="mt-3 pr-25">
                <OutlineButton
                  text= {assetOrderHeaderDetail?.orderRequestType == CONSTANTS.DISPOSITION ? "Save" : "Save Comments" }
                  className="cancel-btn me-0 pull-right"
                  onClick={(e?: any,item?: any) => OnSaveComments(e,item)}
                  disabled={!isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS) || iscommentFieldDisable()}
                 data-attribute="AssetFleetProcessing_Default_Button" />
              </div>
            </Card></div>
          <div className="mt-3">
            <Card data-attribute="AssetFleetProcessing_Default_Card_2">
              {
                transferData?.map((request: any, index: any) => {
                  return assetOrderHeaderDetail?.orderRequestType === CONSTANTS.TRANSFER ?
                    (<div className="transfer-asset-block">
                      <div className='receiving-branch-asset'>
                        <p className="blueLabel">Receiving Branch</p>
                        <Row>
                          <Col xs={12} sm={12} md={4} className='mb-3'>
                            <Label data-attribute="AssetFleetProcessing_Default_Label_2">Cost Center</Label>
                            <ReactSelectBox
                              name='searchedCostCenter'
                              placeholder='Search Cost Center'
                              options={costCentersBySearchList}
                              onChange={(item: any) => onChangeReceivingCostCenter(item, index)}
                              onInputChange={searchCostCenter}
                              value={request?.transferReceivingBranch?.receivingCostCenter ? { label: request?.transferReceivingBranch?.receivingCostCenter, key: request?.transferReceivingBranch?.receivingCostCenter } : { label: "Select", key: "Select" }}
                              isSearchable={true}
                              isDisabled ={isReceivingBranchDisable(request) || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
                              className={(!request?.transferReceivingBranch?.receivingCostCenter || request?.transferReceivingBranch?.receivingCostCenterError?.length) ? 'controlValidation' : ""}
                             data-attribute="AssetFleetProcessing_searchedCostCenter_SearchSelectBox" />
                            {request?.transferReceivingBranch?.receivingCostCenterError?.length ? <p><span className="required">{request?.transferReceivingBranch?.receivingCostCenterError}</span></p> : null}
                          </Col>
                          {(receivingBranchValues || receivingBranchValues == false) && (isShowAlert(request)) && <Col xs={12} sm={12} md={12} className='mb-3'>
                            <Alert
                              className="branch-alert-message-stepper"
                              showAlert={(receivingBranchValues || receivingBranchValues == false) && (isShowAlert(request))}
                              dismissAlert={dismissAlert}
                              type={receivingBranchValues ? "success" : "warning"}
                              text={receivingBranchValues ? "Cost Center changed suceesfully" : "Error while updating the Cost center"}
                             data-attribute="AssetFleetProcessing_Default_Alerts" />
                          </Col>}
                        </Row>
                      </div>
                      <Accordion
                        Items={getExpandedAssetItems(request)}
                        className={`custom-accordion LeaderOrderAccordion capitalLizeAccord `}
                        onChange={(item: any) => onChangeAccordian(item) }
                       data-attribute="AssetFleetProcessing_Default_Accordion_3" />
                    </div>) :
                    <>
                      <Accordion
                        Items={getExpandedAssetItems(request)}
                        className="custom-accordion LeaderOrderAccordion capitalLizeAccord"
                        onChange={(item: any) => { onChangeAccordian(item) }}
                       data-attribute="AssetFleetProcessing_Default_Accordion_4" />
                      {getShowOrderReturn(request) ?
                        <div className="clearfix">
                          <div className="pull-right">
                            <PrimaryButton
                              text='Return Entire Order to Requestor'
                              className='me-0'
                              onClick={(e: any) => handleorderLevelReturn(e, request)}
                             data-attribute="AssetFleetProcessing_Default_Button_2" />
                          </div>
                        </div>

                        : null}
                    </>
                })
              }
            </Card>
          </div>
        </Col>
      </Row>
      {
        Popupcontent.isDialogVisible && (
          <CancelConfirmationPopup
            hideDialog={!Popupcontent.isDialogVisible}
            onDismiss={hideConfirmationDialog}
            Popupcontent={Popupcontent}
            popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
            popupPrimarybtnOnclick={() => Popupcontent?.popupPrimarybtnOnclick()}
          />
        )
      }
      <PopupDialogbox
        hideDialog={!returnPopupcontent.isDialogVisible}
        onDismiss={() => returnPopupcontent?.popupOutlinebtnOnclick()}
        Popupcontent={returnPopupcontent}
        popupOutlinebtnOnclick={() => returnPopupcontent?.popupOutlinebtnOnclick()}
        popupPrimarybtnOnclick={(
          item: any,
          actionby: string,
          value: any) => returnPopupcontent?.popupPrimarybtnOnclick(item,
            actionby,
            value)}

       data-attribute="AssetFleetProcessing_Default_PopupDilalogBox" />
    </>
  )
}

export default AssetFleetProcessing;